// src/services/chatService.js
import { ApiBase } from "../base/api-base";

class ChatService extends ApiBase {
  
  constructor() {
    super('https://tiendabastet.duckdns.org:8084'); // URL específica para el chat
  }


  /**
   * Enviar un mensaje
   * @param {string} message - El mensaje a enviar
   * @param {string} uniqueCode - El código único asociado
   * @returns {Promise<any>} - Respuesta de la API
   */
  async sendMessage(message, uniqueCode) {
    return await this.post('/chat', { message, uniqueCode });
  }

  /**
   * Enviar una imagen
   * @param {File} image - La imagen a enviar
   * @param {string} userEmail - Correo electrónico del usuario
   * @param {string} uniqueCode - El código único asociado
   * @returns {Promise<any>} - Respuesta de la API
   */
  async sendImage(image, userEmail, uniqueCode) {
    const formData = new FormData();
    formData.append('file', image);
    formData.append('uniqueCode', uniqueCode);
    formData.append('userEmail', userEmail);

    return await this.post(`${this.apiUrl}/predict-pruebas`, formData); // Cambiar a 'predic' cuando se use AWS
  }

  /**
   * Enviar una URL de imagen
   * @param {string} imageUrl - URL de la imagen
   * @param {string} uniqueCode - El código único asociado
   * @param {string} userEmail - Correo electrónico del usuario
   * @returns {Promise<any>} - Respuesta de la API
   */
  async sendUrlImage(imageUrl, uniqueCode, userEmail) {
    return await this.post(`${this.apiUrl}/predict-url-pruebas`, 
      { image_url: imageUrl, uniqueCode, userEmail },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  /**
   * Subir una imagen con correo electrónico
   * @param {File} image - La imagen a enviar
   * @param {string} email - El correo electrónico del usuario
   * @param {string} code - El código asociado
   * @returns {Promise<any>} - Respuesta de la API
   */
  async uploadImageWithEmail(image, email, code) {
    const formData = new FormData();
    formData.append('file', image);
    formData.append('email', email);
    formData.append('code', code);

    return await this.post(`${this.apiUrl}/upload-with-email`, formData);
  }

  /**
   * Obtener URLs de productos
   * @param {string[]} nombres - Lista de nombres de productos
   * @returns {Promise<{[key: string]: string}>} - Respuesta de la API
   */
  async obtenerProductosUrls(nombres) {
    let params = new URLSearchParams();
    nombres.forEach(nombre => {
      params.append('nombres', nombre);
    });

    console.log("Parametros enviados para las URL: ", params);

    return await this.get(`${this.apiUrl}/productos_urls?${params.toString()}`);
  }
}

// ✅ Exportar instancia como default
const chatService = new ChatService();
export default chatService;
